(function () {
  'use strict';
  if (window.PPCustomerPresentation) return;
  const main = document.querySelector('.shopify-section--main-product');
  const root = () => main?.querySelector('[data-pp-customer]');
  if (!root()) return;
  window.PPCustomerPresentation = true;
  main.classList.add('pp-customer-product');
  let observer, pending = 0;
  const options = { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-ready', 'src'] };
  const text = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  function refresh() {
    const el = root(); if (!el) return;
    const headings = [...main.querySelectorAll('variant-picker > fieldset .variant-picker__option-info .h-stack')];
    headings.push(el.querySelector('[data-pp-upload-heading]'));
    headings.forEach((heading, index) => {
      if (!heading) return;
      heading.classList.add('pp-step-heading');
      let badge = heading.querySelector(':scope > .pp-step-badge');
      if (!badge) { badge = document.createElement('span'); badge.className = 'pp-step-badge'; heading.prepend(badge); }
      text(badge, el.dataset.stepLabel + ' ' + (index + 1));
    });
    const image = el.querySelector('[data-pp-photo]'), hasPhoto = !!image?.getAttribute('src') && !image.hidden;
    el.dataset.hasPhoto = String(hasPhoto);
    const card = el.querySelector('[data-pp-photo-card]'); if (card) card.hidden = !hasPhoto;
    const confirmation = el.querySelector('[data-pp-photo-confirmed]'); if (confirmation) confirmation.hidden = el.dataset.ready !== 'true';
    text(el.querySelector('[data-pp-open-label]'), hasPhoto ? el.dataset.editLabel : el.dataset.openLabel);
    const summary = hasPhoto ? el.dataset.photoLabel : '';
    if (el.dataset.summary !== summary) el.dataset.summary = summary;
    const frame = main.querySelector('.starboard-super-container');
    let intro = frame?.querySelector('[data-pp-preview-intro]');
    if (frame && !intro) {
      const template = main.querySelector('[data-pp-preview-intro-template]') || document.querySelector('[data-pp-preview-intro-template]');
      if (template) { frame.append(template.content.cloneNode(true)); intro = frame.querySelector('[data-pp-preview-intro]'); }
    }
    if (intro) intro.hidden = hasPhoto;
  }
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(() => { pending = 0; observer.disconnect(); refresh(); observer.observe(main, options); });
  }
  observer = new MutationObserver(schedule);
  refresh(); observer.observe(main, options);
  document.addEventListener('product:rerender', schedule);
  window.addEventListener('pagehide', event => { if (!event.persisted) { observer.disconnect(); cancelAnimationFrame(pending); document.removeEventListener('product:rerender', schedule); } });
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
})();

